import SC from "./style";
import { Button } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { useEffect, useState } from "react";
import { apiPost } from "api/callApi";
import { showAlert } from "utils/helper";

function SendCredential(props) {
  const { handleShow, isOpen, title = "", messageData = "", data } = props;

  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    setIsSending(false);
  }, []);

  const handleCancel = () => {
    handleShow(false);
    setIsSending(false);
    handleShow(false);
  };

  const sendCredentialRequest = async (rowId) => {
    try {
      setIsSending(true);
      const body = {
        userId: data.id,
      };
      const response = await apiPost(`/v1/sendcredential`, body, false);
      showAlert({ title: response.message, icon: "success" });
      setIsSending(false);

      handleCancel();
    } catch (error) {
      console.log(error, "gh");
      showAlert({ title: error?.response?.data?.message, icon: "error" });

      setIsSending(false);
    }
  };

  const renderBody = () => {
    return (
      <SC.Container>
        <SC.MessageDataContainer>
          <SC.MessageData>{`Are you sure you want to send credentials to ${
            data?.fullName || "user"
          }?`}</SC.MessageData>
        </SC.MessageDataContainer>

        <SC.ButtonContiner>
          <Button
            caption="Cancel"
            onClick={handleCancel}
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: "#efefef",
              color: theme.colors.white,
              minWidth: "90px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
          />

          <Button
            caption={isSending ? "Sending..." : "Send"}
            onClick={sendCredentialRequest}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: "#f05455",
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
            disabled={isSending}
          />
        </SC.ButtonContiner>
      </SC.Container>
    );
  };

  return (
    <>
      {isOpen && (
        <BulkActionView
          padding={"10px 15px 5px 15px"}
          fontSize={"13px"}
          title={title}
          openModal={isOpen}
          renderBodyConditionally={renderBody}
          handleCloseModal={() => {
            handleCancel();
          }}
          sx={{
            minWidth: "550px",
          }}
        />
      )}
    </>
  );
}

export default SendCredential;
